"use strict";

// Single source for the club_applications (type "club_creation") clubData
// schema limits. Firestore enforces no schema, so every party that writes or
// validates this shape reads these numbers:
//  - the app's Create Club form (components/home/CreateClubSheet.js maxLength),
//  - the approval callable's validator (clubApproval.js buildClubDocument),
//  - firestore.rules club_applications create (name cap; pinned by
//    test/schemaUniformity.test.js so the rules cannot drift).
// Plain CommonJS with no imports so Metro and Node both load it.
const CLUB_APPLICATION_LIMITS = Object.freeze({
  name: 200,
  description: 10000,
  linkUrl: 2048,
  linkName: 160,
  list: 50,
  gallery: 8,
});

// Storage folders a club application may point at. The approval callable
// keeps only download URLs of THIS project's bucket under these folders
// (gallery: the applicant's own staging folder), so a request written
// straight through the SDK cannot publish off-site images or files.
const CLUB_APPLICATION_STORAGE_PREFIXES = Object.freeze({
  logo: "club-logos/",
  pdf: "club-documents/",
  gallery: (uid) => `club-gallery-staging/${uid}/`,
});

function isStorageUrlIn(url, bucket, folder) {
  if (typeof url !== "string" || !bucket) return false;
  const base = `https://firebasestorage.googleapis.com/v0/b/${bucket}/o/`;
  if (!url.startsWith(base)) return false;
  const encodedPath = url.slice(base.length).split("?")[0];
  let objectPath;
  try { objectPath = decodeURIComponent(encodedPath); } catch { return false; }
  return objectPath.startsWith(folder) && !objectPath.includes("..");
}

module.exports = { CLUB_APPLICATION_LIMITS, CLUB_APPLICATION_STORAGE_PREFIXES, isStorageUrlIn };
